var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Logic",on:{"click":function($event){$event.stopPropagation();return _vm.change($event)}}},[(_vm.label)?_c('span',{staticClass:"Logic-label",class:{'Logic-label-active' : _vm.activeComp}},[_vm._v("\n  \n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/LogicBox/LogicBox.vue